import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import ImmutablePropTypes from 'react-immutable-proptypes';
import { selectQuotationsForCurrentBib, selectUgcSummary } from 'app/selectors/bibs/UgcSelector';
import { selectFlaggedContentVisibility } from 'app/selectors/bibs/ContentWarningsSelector';
import { selectCatalogBib } from 'app/selectors/catalogBibs/CatalogBibSelector';
import { selectQuotationsTransactions } from 'app/selectors/ugc/QuotationsSelector';
import { userIdentityShape, ugcFlagShape, catalogBibShape } from '@bibliocommons/bc-prop-types';
import { selectUserEntities, selectFlagEntities } from 'app/selectors/EntitiesSelector';
import contentWarningActions from 'app/actions/ContentWarningActions';
import BibsActions from 'app/actions/BibsActions';
import { Quotations } from '.';

export class QuotationsContainer extends React.PureComponent {
  render() {
    return <Quotations {...this.props} />;
  }
}

QuotationsContainer.propTypes = {
  users: ImmutablePropTypes.mapOf(userIdentityShape).isRequired,
  quotations: ImmutablePropTypes.list.isRequired,
  quotationsTransactions: ImmutablePropTypes.map.isRequired,
  summary: ImmutablePropTypes.map,
  flags: ImmutablePropTypes.mapOf(ugcFlagShape),
  flaggedContentVisibility: ImmutablePropTypes.mapOf(ImmutablePropTypes.map),
  contentWarningActions: PropTypes.objectOf(PropTypes.func).isRequired,
  bibsActions: PropTypes.objectOf(PropTypes.func).isRequired,
  catalogBib: catalogBibShape.isRequired
};

const mapStateToProps = state => ({
  users: selectUserEntities(state),
  quotations: selectQuotationsForCurrentBib(state),
  quotationsTransactions: selectQuotationsTransactions(state),
  summary: selectUgcSummary(state),
  flags: selectFlagEntities(state),
  flaggedContentVisibility: selectFlaggedContentVisibility(state),
  catalogBib: selectCatalogBib(state)
});

const mapDispatchToProps = dispatch => ({
  contentWarningActions: bindActionCreators(contentWarningActions, dispatch),
  bibsActions: bindActionCreators(BibsActions, dispatch)
});

export default connect(mapStateToProps, mapDispatchToProps)(QuotationsContainer);
